import React from 'react';
import { Button, Dropdown } from 'antd';
import { EPButton } from '@/components';
import { getActionsMenuItemsBasedOnStatus, getBackGroundColorBasedOnStatus, getTextBasedOnStatus, getPublishEditMenuBasedOnStatus, canShowThreeDots } from './ReportPage.utils';
import { handlePublishClick, handleEditClick, handleMenuClick, VerticalThreeDots } from './columns.utils';
import { ReportGeneratorStatus } from '@/constants/ReportGeneratorStatus.enum';
import { token } from '@/theme';
import ReportStore from '@/store/Report/ReportStore';

interface ReportRecord {
  id?: string;
  title?: string;
  reportDetails?: string;
  status?: string;
  version?: string;
  [key: string]: unknown;
}

const SingleDot = ({ backgroundColor }: { backgroundColor: string }) => (
  <div style={{ width: '6px', height: '6px', borderRadius: '50%', backgroundColor: backgroundColor }} />
);

export const getColumns = (
  t: (key: string) => string,
  onPublishClick?: (record: ReportRecord) => void,
  reportStore?: ReportStore,
  onRefreshReports?: () => void,
  onDeleteClick?: (record: ReportRecord) => void
) => {
  return [
    {
      title: t('reportDetails'),
      dataIndex: 'reportDetails',
      key: 'reportDetails',
      width: '30%',
      render: (text: string) => (
        <div>
          <div>{text || '-'}</div>
        </div>
      ),
    },
    {
        title: t('dateCreated'),
        dataIndex: 'dateCreated',
        key: 'dateCreated',
        width: '18%',
        render: (text: string) => (
          <div>
            <div>{text || '-'}</div>
          </div>
        ),
    },
    {
        title: t('createdBy'),
        dataIndex: 'createdBy',
        key: 'createdBy',
        width: '18%',
        render: (text: string) => (
          <div>
            <div>{text || '-'}</div>
          </div>
        ),
    },
    {
        title: t('status'),
        dataIndex: 'status',
        key: 'status',
        width: '18%',
          render: (text: string, record: ReportRecord) => {
            const statusValue = text || record.status || '';
            if (!statusValue) return <div>-</div>;
            return (
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <SingleDot 
                  backgroundColor={getBackGroundColorBasedOnStatus(statusValue as ReportGeneratorStatus)} 
                /> 
                {typeof getTextBasedOnStatus(statusValue as ReportGeneratorStatus, t) === 'string' 
                  ? <span>{getTextBasedOnStatus(statusValue as ReportGeneratorStatus, t) as string}</span>
                  : getTextBasedOnStatus(statusValue as ReportGeneratorStatus, t) as React.ReactElement
                }
              </div>
            );
          },
    },
    {
        title: t('actions'),
        dataIndex: 'actions',
        key: 'actions',
        width: '18%',
        render: (_text, record: ReportRecord) => {
          
          const publishEditItems = getPublishEditMenuBasedOnStatus(record.status as ReportGeneratorStatus, t);
          const items = getActionsMenuItemsBasedOnStatus(record.status as ReportGeneratorStatus, t);

          const onPublishClickHandler = () => {
            handlePublishClick(record, onPublishClick);
          };

          const onEditClickHandler = async () => {
            await handleEditClick(record, reportStore, t);
          };

          const onMenuClickHandler = async ({ key }: { key: string }) => {
            await handleMenuClick(key, record, reportStore, t, onRefreshReports, onDeleteClick);
          };

          const showThreeDots = canShowThreeDots(record.status as ReportGeneratorStatus);
          
          return (
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', alignItems: 'center', paddingRight: showThreeDots ? 0 : 40 }}>
              {publishEditItems.map((item) => {
                if (item.key === 'Publish') {
                  return (
                    <Button key={item.key} style={{ padding: 0, color: token.colorPrimary}} type="text" onClick={onPublishClickHandler}>
                      {item.label}
                    </Button>
                  );
                } else if (item.key === 'Edit' || item.key === 'View') {
                  return (
                    <Button style={{ padding: 0, color: token.colorPrimary}} key={item.key} type="text" onClick={onEditClickHandler}>
                      {item.label}
                    </Button>
                  );
                }
                return null;
              })}
              {showThreeDots && (
                <Dropdown menu={{ items, onClick: onMenuClickHandler }} trigger={['click']}>
                  <EPButton type="text" icon={<VerticalThreeDots />} />
                </Dropdown>
              )}
            </div>
          );
        },
    },
  ];
};